export default "__VITE_ASSET__jp8NNHqT__"